module.exports = __webpack_public_path__ + "static/media/bed_new_pack_dog_EN_768x290.a3a0c42d.png";